import clsx from 'clsx';

const TITLE_WIDTHS = ['w-28', 'w-36', 'w-32'] as const;

/** Three tiles: guessing high would collapse the grid when a shorter tray arrives. */
export const CopilotHomeV2Loader = () => (
  <div className="py-8" aria-busy="true" aria-live="polite">
    <span className="sr-only">Loading...</span>
    <div className="mx-auto w-full max-w-4xl">
      <div className="h-8 w-96 max-w-full animate-pulse rounded-md bg-neutral-200 dark:bg-neutral-700" />
      <div className="mt-3 h-4 w-72 max-w-full animate-pulse rounded bg-neutral-200 dark:bg-neutral-700" />

      <div className="mt-8 flex flex-col gap-2 rounded-3xl bg-white dark:bg-neutral-800 p-5 shadow">
        <div className="h-6 w-28 animate-pulse rounded bg-neutral-100 dark:bg-neutral-700" />
        <div className="flex flex-row justify-end gap-2">
          <div className="size-8 animate-pulse rounded-full bg-neutral-100 dark:bg-neutral-700" />
          <div className="size-8 animate-pulse rounded-full bg-neutral-200 dark:bg-neutral-700" />
        </div>
      </div>

      <div className="mt-8 flex items-center justify-end">
        <div className="h-9 w-36 animate-pulse rounded-lg bg-neutral-200 dark:bg-neutral-700" />
      </div>

      <div className="mt-3.5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
        {TITLE_WIDTHS.map((titleWidth, index) => (
          <div
            key={index}
            className="flex min-h-32 flex-col gap-2.5 rounded-xl border border-neutral-200/50 dark:border-neutral-700/50 bg-white dark:bg-neutral-800 p-4 shadow-sm"
          >
            <div className="size-8 animate-pulse rounded bg-neutral-100 dark:bg-neutral-700" />
            <div
              className={clsx(
                'h-4 animate-pulse rounded bg-neutral-200 dark:bg-neutral-700',
                titleWidth
              )}
            />
            <div className="h-3 w-full animate-pulse rounded bg-neutral-100 dark:bg-neutral-700" />
            <div className="h-3 w-2/3 animate-pulse rounded bg-neutral-100 dark:bg-neutral-700" />
          </div>
        ))}
      </div>
    </div>
  </div>
);
